function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { assert, useId } from "../../utils";
import { Text } from "../Text";
import { AccessibilityFillIcon, CloseOutlineIcon } from '@applyboard/ui-icons';
import { Flex } from "../Flex";
import { useSlate } from 'slate-react';
import { useMemo } from 'react';
import visit, { EXIT } from 'unist-util-visit';
import { HelpText } from "../HelpText";
import { Button } from "../Button";
import { convertMarkdownStringToSlateTree } from "./RichTextEditor.utils";
import { isArray } from "../../utils/isArray";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
export var ACCESSIBILITY_ERROR_MESSAGE = 'Some accessibility issues were found.  Please review the the Accessibility Checker results';
export function AccessibilityPanel(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    closeButtonRef = _ref.closeButtonRef;
  var labelId = useId();
  var editor = useSlate();
  var children = editor.children;
  var notices = useMemo(function () {
    return generateAccessibilityNotices(children);
  }, [children]);
  if (!open) {
    return null;
  }
  return _jsx("aside", {
    css: function css(theme) {
      return {
        paddingTop: theme.spacing[2],
        paddingBottom: theme.spacing[2],
        paddingLeft: theme.spacing[4],
        paddingRight: theme.spacing[4],
        width: '300px',
        flexGrow: 0,
        flexShrink: 0,
        borderLeft: "1px solid ".concat(theme.colors.borderInactive),
        backgroundColor: 'white',
        overflowY: 'auto',
        '@container (max-width: 680px)': {
          position: 'absolute',
          right: 0,
          height: '100%',
          boxShadow: '0px 2px 4px rgba(59, 65, 83, 0.12)'
        }
      };
    },
    "aria-labelledby": labelId,
    children: _jsxs(Flex, {
      direction: "column",
      gap: 2,
      children: [_jsxs(Flex, {
        justify: "between",
        children: [_jsxs(Flex, {
          align: "center",
          gap: 2,
          children: [_jsx(AccessibilityFillIcon, {}), _jsx(Text, {
            id: labelId,
            variant: "titleS",
            children: "Accessibility Checker"
          })]
        }), _jsx(Button, {
          ref: closeButtonRef,
          onClick: onClose,
          leadIcon: CloseOutlineIcon,
          "aria-label": "Close",
          size: "sm",
          emphasis: "transparent"
        })]
      }), _jsx(Text, {
        variant: "bodyS",
        intent: "secondary",
        children: notices.length === 0 ? 'No accessibility issues found' : 'Please review the following accessibility issues to ensure your content is as inclusive as possible'
      }), notices.map(function (notice, index) {
        return _jsx(HelpText, {
          showIcon: true,
          intent: notice.intent,
          children: notice.text
        }, index);
      })]
    })
  });
}
export function validateMarkdownAccessibility(markdown) {
  var slateTree = convertMarkdownStringToSlateTree(markdown);
  var accessibilityNotices = generateAccessibilityNotices(slateTree);
  if (accessibilityNotices.length > 0) {
    return ACCESSIBILITY_ERROR_MESSAGE;
  }
  return true;
}
function generateAccessibilityNotices(children) {
  var warnings = [];
  var firstHeading = null;
  var previousHeading = null;
  visit({
    type: 'root',
    children: children
  }, 'heading', function (node) {
    assert('depth' in node && typeof node.depth === 'number');
    if (isEmptyNode(node)) {
      warnings = [{
        text: "Found empty headings.  Please ensure all blank lines are not headings",
        intent: 'negative'
      }];
      return EXIT;
    }
    if (firstHeading === null) {
      firstHeading = node.depth;
      if (firstHeading !== 1) {
        warnings.push({
          text: _jsxs(_Fragment, {
            children: ["The first heading must be 'Heading\xA01'. Found 'Heading\xA0", firstHeading, "' instead"]
          }),
          intent: 'negative'
        });
      }
    }
    if (previousHeading !== null && node.depth > previousHeading + 1) {
      warnings.push({
        text: _jsxs(_Fragment, {
          children: ["Heading levels should not be skipped. Found 'Heading\xA0", node.depth, "' after 'Heading\xA0", previousHeading, "'"]
        }),
        intent: 'negative'
      });
    }
    previousHeading = node.depth;
  });
  return warnings;
}
function isEmptyNode(node) {
  if (_typeof(node) === 'object' && node && 'children' in node && isArray(node.children)) {
    return node.children.every(isEmptyNode);
  }
  if (_typeof(node) === 'object' && node && 'text' in node && typeof node.text === 'string' && node.text === '') {
    return true;
  }
  return false;
}